  <div class="ng-autocomplete">
    <div class="label">
      {{label}}
    </div>
    <ng-autocomplete #autocomplete
      [data]="data"
      [searchKeyword]="searchKeyword"
      [placeholder]="isPanelOpen ? placeholder : ''"
      (selected)='selectEvent($event)'
      (inputChanged)='onChangeSearch($event)'
      (inputFocused)='onFocused($event)'
      (inputCleared)="onCleared()"
      (opened)="isPanelOpen = true"
      (closed)="isPanelOpen = false"
      [historyIdentifier]="historyIdentifier"
      [historyHeading]="historyHeader"
      [initialValue]="initialValue"
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate"
      [formControl]="control"
      [ngClass]="{'error': isInvalid(), 'uppercase': upperCase}">
    </ng-autocomplete>

    <ng-container *ngIf="isInvalid()">
      <img *ngIf="!control.value"
        class="error-icon"
        src="assets/icons/icon-field-error.svg"
        alt="error-icon"
      />
      <div class="error-message">
        This field is required
      </div>
    </ng-container>

    <ng-template #itemTemplate let-item>
      <a class="dropdown-item" [innerHTML]="item.name"></a>
    </ng-template>
  
    <ng-template #notFoundTemplate let-notFound>
      <div class="add-item-container" (click)="addItem()">
        Add "{{search?.toUpperCase()}}"
      </div>
    </ng-template>
  </div>